import DynamicMaxWeight from '@/Formulate/Rules/DynamicMaxWeight'

window._ = require('lodash')
require('deepdash/addFindValueDeep')(_)
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
import filters from './lib/filters' //es-lint-disable-line
import VueSmoothScroll from 'vue2-smooth-scroll'

require('../sass/app.scss')

import { createInertiaApp, Link } from '@inertiajs/inertia-vue'
import { Inertia } from '@inertiajs/inertia'
import Vue from 'vue'
import Vuex from 'vuex'
import Clarity from '@microsoft/clarity'
import store from './store'
import VueMeta from 'vue-meta'
import { InertiaProgress } from '@inertiajs/progress/src'

import VueFormulate from '@braid/vue-formulate'
import VCalendar from 'v-calendar'
import VueApexCharts from 'vue-apexcharts'
import axiosInstance from './lib/api'
import laravel from './Mixin/laravel'
import mobile from './Mixin/mobile'
import FormulateAddress from '@/Formulate/Address'
import FormulateDocuments from '@/Formulate/Documents'
import FormulateIconInput from '@/Formulate/IconInput'
import FormulateSubForms from '@/Formulate/SubForms'
import FormulateVCalendar from '@/Formulate/VCalendar'
import FormulateRepeaterRadio from '@/Formulate/RepeaterRadio'
import FormulateYesNoExplain from '@/Formulate/YesNoExplain'
import FormulateAI from '@/Formulate/AddInsured'
import FormulateSignature from '@/Formulate/Signature'
import NNumber from '@/Formulate/NNumber'
import FormulateRuleStrMax from '@/Formulate/Rules/StringMax'
import FormulateRuleRequiredAllowed from '@/Formulate/Rules/RequiredAllowedString'

import { BootstrapVue } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)
library.add(fab)
library.add(far)

Vue.use(BootstrapVue, {
	'BToast': {
		autoHideDelay: 8000,
		toaster: 'b-toaster-top-center'
	}
})

Vue.config.productionTip = false
Vue.mixin({ methods: { route: window.route } })
Vue.use(VueMeta)
Vue.use(Vuex)

Vue.use(VueFormulate, {
	uploader: axiosInstance,
	classes: {
		inputHasErrors: 'is-invalid',
		help: 'form-text text-muted',
		errors: 'list-unstyled text-danger'
	},
	plugins: [
		FormulateSubForms,
		FormulateAddress,
		FormulateDocuments,
		FormulateIconInput,
		FormulateVCalendar,
		FormulateRepeaterRadio,
		FormulateYesNoExplain,
		FormulateSignature,
		FormulateAI,
		NNumber
	],
	rules: {
		strMax: FormulateRuleStrMax,
		requiredAllowed: FormulateRuleRequiredAllowed,
		dynamicMaxWeight: DynamicMaxWeight
	},
	messages: {
		strMax: 'The entered value exceeds the maximum allowed'
	}
})

Vue.use(VueSmoothScroll)

Vue.use(VCalendar)

Vue.use(VueApexCharts)
Vue.component('Apexchart', VueApexCharts)
Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component('Link', Link)

Vue.prototype.$route = (...args) => route(...args).url()

InertiaProgress.init({
	// The delay after which the progress bar will
	// appear during navigation, in milliseconds.
	delay: 100,

	// The color of the progress bar.
	color: '#AB8C37',

	// Whether to include the default NProgress styles.
	includeCSS: true,

	// Whether the NProgress spinner will be shown.
	showSpinner: false
})

Vue.mixin(laravel)
Vue.mixin(mobile)

if (process.env.NODE_ENV === 'production') {
	Inertia.on('navigate', (event) => {
		if (typeof gtag !== 'undefined') {
			gtag('js', new Date())

			let page = event.detail.page || {}
			let props = page.props || {}

			gtag('config', 'G-KTJQRX8MEZ', {
				'page_path': page.url || '/',
				'user_id': props.auth ? props.auth.id : null
			})
		}

		Clarity.init('p8zt8an5c8')

		let page = event.detail.page || {}
		let props = page.props || {}

		if (props.auth) {
			Clarity.identify(props.auth.id)
			Clarity.setTag('auth-name', props.auth.full_name)
			Clarity.setTag('auth-email', props.auth.email)
		}
	})
}

createInertiaApp({
	resolve: name => import(`@/Pages/${name}`).then(module => module.default),
	setup ({ el, App, props, plugin }) {
		Vue.use(plugin)

		new Vue({
			store,
			metaInfo: {
				titleTemplate: (title) => title ? `${title} - O2 Sports Insurance` : 'O2 Sports Insurance'
			},
			render: h => h(App, props)
		}).$mount(el)
	}
}).then()
